import React from 'react'
import addDefaultSrc from '../assets/ic_cc.svg';
import './modalproductonoeditorial.css';
import './NotificacionPopUp.css'
import fondonotificacion from '../assets/fondonotificacion.png'

const PopUp = ({popUp, marcarNotifLeida, consultarMostrarPopUpLista, obtenerNotificaciones}) => {

    const renderPopUpOAnuncio = () => {

        const renderImagen = () => {
            if (popUp.tieneImagen) {
                return(
                    <img alt=""
                        className="d-block w-100 carousel-img"
                        src={popUp.urlImagen}
                        onError={(e) => e.target.src = addDefaultSrc}
                        style={{height: '200px', width: '265px'}}
                        onClick={() => {
                            if (popUp.link) {
                                let url = popUp.url
                                let a =  window.open(url, '_blank')
                                a.focus();
                            }

                        }}
                    />
                )
            }
        }

        // Si popUp.notificacionTipoId == 3  entonces es notificacion Te extrañamos

        return (
            <div className="" id="productoNoEditorial">
                <div className="" >

                    {popUp.notificacionTipoId == 3 ? 
                    (
                        <div className="modal-header d-flex justify-content-center">
                            <h3>
                                {popUp.titulo}
                            </h3>
                        </div>
                    )
                    :
                    (
                        <div className="modal-header d-flex">
                            <h6 className="modal-title">
                                {popUp.titulo}
                            </h6>
                        </div>
                    )
                    }
                    
                    <div className="modal-body-notificacion" style={{textAlign: 'left', cursor: popUp.link ? 'pointer' : 'default'}}
                        onClick={() => {
                            if(popUp.link) {
                                let url = popUp.url
                                let a = window.open(url, '_blank'); 
                                a.focus();
                            }
                        }}
                    >
                        <div>
                            {renderImagen()}
                        </div>
                        <div className={`${popUp.notificacionTipoId == 3 ? 'text-center' : 'text-justify pt-3'}`} 
                            dangerouslySetInnerHTML={{ __html: popUp.mensaje }}>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    const estilosTeExtrañamos = {
        backgroundImage: "url(" + fondonotificacion + ")",
        backgroundSize: 'cover', 
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        color: 'white'
    }

    return (
        <div className="popUpNotif" key={popUp.notificacionId}>
            <div className="modal-content" style={popUp.notificacionTipoId == 3 ? estilosTeExtrañamos : null}>
                {renderPopUpOAnuncio()}
                <div className="modal-footer">
                    <button 
                        className='close-button' 
                        onClick={async () => {
                            let campanita = document.getElementById('campanita');
                            if(campanita) campanita.style.pointerEvents = 'all'
                            let body = document.getElementById('body')
                            body.style.pointerEvents = 'all';
                            marcarNotifLeida(popUp.notificacionId, consultarMostrarPopUpLista, obtenerNotificaciones);

                            // id 1 representa la accion "Refresh".
                            if(popUp.accion === 1) {
                                window.location.reload();
                            }
                        }}
                        style={{
                            display: popUp.esInvasivo ?  'none' : 'all'
                        }}
                    >
                        Aceptar
                    </button>
                </div>
            </div>
        </div>
    )
}

export default PopUp